import { mixins, styled } from '@pulse-web-ui/theme';

export const PaymentPeriodCardDescriptionWrapper = styled.div`
  ${mixins.flex({ gap: 6 })}
`;
